import type { FilterOption } from '@app/types/filter'

export const filterOptions: FilterOption[] = [
  {
    value: 'name',
    label: 'Наименование товара'
  },
  {
    value: 'trendCode',
    label: 'Направление'
  },
  {
    value: 'purchasingGroupCode',
    label: 'Группа закупок'
  },
  {
    value: 'commodityGroupCode',
    label: 'Товарная группа'
  },
  {
    value: 'categoryCode',
    label: 'Категория'
  },
  {
    value: 'subcategoryCode',
    label: 'Подкатегория'
  }
]
